<template>
    <div class="created_company_store">
        <section class="breadcrumb-section pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <!-- <li class="breadcrumb-item"><a href="#">Cart</a></li> -->
                        <li class="breadcrumb-item active" aria-current="page">
                            Company Store
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="created_company_store_store_banner mt_20">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="created_store_banner">
                            <img
                                src="maincss/images/create-compnay.png"
                                alt="img"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section
            class="cmn-section item-category-list created_product_items_cat_list"
        >
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-4 col-xl-3">
                        <div class="side_bar">
                            <div class="serach d-flex">
                                <label>Search</label>
                                <div class="search_field pl_10">
                                    <input
                                        type="text"
                                        placeholder="e.g. T-Shirt, Cap"
                                        class="form-control"
                                    />
                                    <a href="#" class="search_icon"
                                        ><img
                                            src="/maincss/images/side_bar_serach.svg"
                                            alt=" "
                                    /></a>
                                </div>
                            </div>
                            <div class="categorys mt_40">
                                <h5 class="font-weight-bold heading5 mb_10">
                                    All Category
                                </h5>
                                <a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    NEW
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Brands
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    T-Shirts
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Polos/Knits
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Sweatshirts/Fleece
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Caps
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Activewear
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Outerwear
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Woven/Dress Shirts
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Workwear
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Bags
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Accessories
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Ladies/Women
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto" /></a
                                ><a
                                    href="/product-list"
                                    class="category_link w-100 d-flex justify-content-center align-items-center"
                                >
                                    Youth
                                    <img
                                        src="/maincss/images/side_bar_category_arrow.svg"
                                        alt=" "
                                        class="ml-auto"
                                /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-8 col-xl-9">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/product_2.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/tshirt_product_2.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/tshirt_product_3.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/tshirt_product_4.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/tshirt_product_5.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/product_2.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <nav
                                    aria-label="Page navigation example"
                                    class="d-flex created_store_page_pagination"
                                >
                                    <ul class="pagination ml-auto mb-0">
                                        <li class="page-item previous">
                                            <a href="#" class="page-link"
                                                ><img
                                                    src="/maincss/images/previous_arrow.svg"
                                                    alt=""
                                                    class="mr_10"
                                                />
                                                Previous</a
                                            >
                                        </li>
                                        <li class="page-item active">
                                            <a href="#" class="page-link">1</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="#" class="page-link">2</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="#" class="page-link">3</a>
                                        </li>
                                        <li class="page-item next active">
                                            <a href="#" class="page-link"
                                                >Next
                                                <img
                                                    src="/maincss/images/next_arrow.svg"
                                                    alt=""
                                                    class="ml_10"
                                            /></a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "CreatedCompanyStore",
    components: {},
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
        document.body.classList.add("footer_spacing_mange");
    }
};
</script>
